export const AUDIT_ENGAGEMENT_ID_QUERY_PARAM = "auditEngagementId";
export const ALLOCATION_WINDOW_QUERY_PARAM = "allocationWindowId";
export const AUDIT_PLANNER_PAGE_QUERY_PARAM = "ap_page";

export const ALLOCATION_REFETCH_INTERVAL_MS = 10000;
